import { FoutVak, Kop, Laden, Leeg } from '../onderdelen/ui'
import { useFactuur } from '../lib/factuur'
import { datumKort, moment } from '../lib/opmaak'
import type { Gebeurtenis } from '../lib/types'
import { historieTekst, historieWat, verborgen } from '../lib/zicht.ts'

/* ===========================================================================
 *  Tijdlijn: wat er met deze factuur gebeurde, nieuwste bovenaan
 *
 *  Uit expense_gebeurtenis, dezelfde historie als in het dashboard. Blue10
 *  zet er "van > naar" onder; hier staat wie het deed, en wat erbij werd
 *  gezegd (een opmerking, een reden, wat er veranderde).
 * =========================================================================== */

/*
 * Gelijk aan de historie in TW10 Online (21 okt 2026). Casper: "mobiele
 * versie staat nu niet gelijk aan desktop versie, qua logs ect" -- en de
 * desktop is de maat ("de desktop is goed nu"). Op 23 okt 2026 nog eens:
 * "dingen zoals de auditlogs ect, ook op telefoon hetzelfde". De woorden
 * (HISTORIE, VELD) en wat er niet in mag (VERBORGEN) staan sinds die dag in
 * lib/zicht.ts, de kopie van wat de functie gebruikt; de zelftest van het
 * dashboard legt ze naast Detail.tsx. Een gewijzigd veld heet "<veld>
 * gewijzigd", met "oud → nieuw" eronder; In dispuut gezet en Uit dispuut
 * gehaald heten hier nu ook zo.
 */

/*
 * De tijd naast de datum. Casper (21 okt 2026): "tijden bij tijdlijn
 * toevoegen, nu is het onduidelijk of het in de ochtend, middag of avond
 * gedaan is." Met alleen "21 10 26" staan drie stappen van één dag naast
 * elkaar alsof ze tegelijk gebeurden.
 */
const twee = (n: number) => String(n).padStart(2, '0')
function uur(ms: number | null | undefined): string {
  if (!ms) return ''
  const d = new Date(ms)
  return `${twee(d.getHours())}:${twee(d.getMinutes())}`
}

function regelOnder(g: Gebeurtenis): string {
  const wie = g.doorNaam || 'Systeem'
  const tekst = historieTekst(g)
  return tekst ? `${wie} · ${tekst}` : wie
}

export default function Tijdlijn({ id }: { id: string }) {
  const { antwoord, op, fout, laden, ververs } = useFactuur(id)

  return (
    <div className="scherm">
      <Kop terugNaar={`/factuur/${encodeURIComponent(id)}`} terugLabel="Factuur" titel="Tijdlijn" />
      {fout && <FoutVak tekst={fout} opnieuw={() => void ververs()} />}
      {!antwoord && laden && <Laden />}
      {antwoord && (
        <>
          <button className="bijgewerkt" onClick={() => void ververs()}>
            <span className="groot">{moment(op)}</span>
            <span className="klein zacht">{laden ? 'Bezig met bijwerken…' : 'Voor het laatst bijgewerkt'}</span>
          </button>
          {antwoord.tijdlijn.length === 0 && <Leeg>Er staat nog niets in de tijdlijn.</Leeg>}
          <ul className="lijst tijdlijn">
            {antwoord.tijdlijn.filter((g) => !verborgen(g)).map((g) => (
              <li key={g.id}>
                <div className="lijst-rij tl-rij">
                  <span className="tl-kant">
                    <span>{datumKort(g.at)} <span className="zacht">{uur(g.at)}</span></span>
                    <span className="klein zacht">Datum en tijd</span>
                  </span>
                  <span className="tl-kant rechts">
                    <span>{historieWat(g)}</span>
                    <span className="klein zacht">Actie</span>
                  </span>
                </div>
                <div className="tl-onder">{regelOnder(g)}</div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
